import { useState, useEffect, useRef } from 'react'
import { apiService } from '../services/api'

export interface LeadOption {
 value: string
 label: string
 color?: string
}

export interface LeadOptions {
 statuses: LeadOption[]
 sources: LeadOption[]
 funnelStages: LeadOption[]
}

export const useLeadOptions = () => {
 const [options, setOptions] = useState<LeadOptions>({
 statuses: [],
 sources: [],
 funnelStages: [],
 })
 
 const [isLoading, setIsLoading] = useState(false)
 const [error, setError] = useState<string | null>(null)
 const hasLoadedRef = useRef(false)

 const fetchLeadOptions = async () => {
 try {
 setIsLoading(true)
 setError(null)
 console.log('🔄 Buscando opções de leads...')
 const response = await apiService.getLeadOptions()
 console.log('✅ Opções de leads carregadas:', response)
 
 // Mapeia a resposta para a estrutura esperada
 const mappedOptions = {
 statuses: response.statuses || [],
 sources: response.sources || [],
 funnelStages: response.funnelStages || []
 }
 
 setOptions(mappedOptions)
 } catch (err) {
 console.error('❌ Erro ao buscar opções de leads:', err)
 setError('Erro ao carregar opções de leads')
 
 // Fallback para valores padrão em caso de erro
 setOptions({
 statuses: [
 { value: 'new', label: 'Novo', color: '#3B82F6' },
 { value: 'contacted', label: 'Contatado', color: '#EAB308' },
 { value: 'qualified', label: 'Qualificado', color: '#06B6D4' },
 { value: 'proposal', label: 'Proposta Enviada', color: '#A855F7' },
 { value: 'negotiation', label: 'Em Negociação', color: '#F59E0B' },
 { value: 'converted', label: 'Convertido', color: '#10B981' },
 { value: 'lost', label: 'Perdido', color: '#EF4444' }
 ],
 sources: [
 { value: 'website', label: 'Website' },
 { value: 'phone', label: 'Telefone' },
 { value: 'whatsapp', label: 'WhatsApp' },
 { value: 'email', label: 'E-mail' },
 { value: 'social_media', label: 'Redes Sociais' },
 { value: 'referral', label: 'Indicação' },
 { value: 'walk_in', label: 'Visita Presencial' },
 { value: 'partner', label: 'Parceiro' },
 { value: 'other', label: 'Outro' }
 ],
 funnelStages: [],
 })
 } finally {
 setIsLoading(false)
 }
 }

 useEffect(() => {
 if (!hasLoadedRef.current) {
 fetchLeadOptions()
 hasLoadedRef.current = true
 }
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [])

 return {
 options,
 isLoading,
 error,
 fetchLeadOptions
 }
}
